import { Modal, Form, Button, Col, Dropdown, Input, Layout, List, Menu, message, Row, Space, Select, Spin, Tooltip, FormInstance, GetProp, UploadFile, UploadProps, Card, Upload, Table, ModalProps } from 'antd'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { ProFormInstance, ProFormText, ProFormTextArea, ProFormDigit, ProFormSwitch, ProFormSelect, ProFormRadio, ModalForm, ProFormList } from '@ant-design/pro-form'
import { getCourierInfo } from '../../api/response'
import { CompleteShipmentRequestTypes } from '../../models/order/orderDetail'
import api from '../../config/api'

import styled from 'styled-components'
const UploadStyle = styled.div`
  .ant-upload.ant-upload-select-picture-card {
    width: 100%;
    margin: 0;
    height: 100%;
  }
  .ant-upload.ant-upload-select-picture-card > .ant-upload > span {
    width: 100%;
    height: 100%;
  }
  .ant-upload-list-picture-card-container {
    width: 100%;
    height: 150px;
  }
  .ant-upload-list-picture-card-container img {
    object-fit: cover;
  }
`

const UploadInner = styled.div`
  .ant-upload.ant-upload-drag .ant-upload-drag-container {
    display: table-cell;
    vertical-align: middle;
  }
`
type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

export type CompleteShipmentFormProps = {
  visible: boolean;
  onCancel: any;
  onSubmit: (values: CompleteShipmentRequestTypes) => Promise<void>;
  /** @name 弹框的标题 */
  title?: ModalProps['title'];
  width?: any;
  formValues?: any;
};

const CompleteShipmentForm: React.FC<CompleteShipmentFormProps> = (props) => {
  const formRef = useRef<ProFormInstance<any> | undefined>();
  const [newValue, setNewValue] = useState<any>({})
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const onPreview = async (file: UploadFile) => {
    let src = file.url as string;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj as FileType);
        reader.onload = () => resolve(reader.result as string);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };
  const onChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  return (
    <ModalForm title={props.title}
      grid={true}
      visible={props.visible}
      autoFocusFirstInput
      initialValues={props.formValues}
      modalProps={{
        destroyOnClose: true,
        onCancel: () => { props.onCancel(); },
      }}

      onFinish={async (values) => {
        props.onSubmit({ ...values })
      }}
      layout="horizontal"
      autoComplete="off"
      onValuesChange={(value, all) => { setNewValue({ ...newValue, ...all }); }}
      formRef={formRef} >
      {/* <ProFormSelect colProps={{ md: 8 }}
        style={{ width: '200px' }}
        name="courier"
        label="公司"
        request={async () => {
          const res = await getCourierInfo()
          if (res.success) {
            return res.data.map((item: any) => ({
              label: item.name + '(' + item.code + ')',
              value: item.code,
            }))
          } else {
            message.error(res.message)
            return []
          }
        }}
        rules={[{ required: true, message: '请选择' }]}
      />
      <ProFormText name="trackingNo" label="单号" colProps={{ md: 10 }} ></ProFormText>
      <ProFormDigit name="weight" label="包裹重量" colProps={{ md: 6 }} min={0} fieldProps={{ addonAfter: "kg", precision: 2, controls: false }}></ProFormDigit> */}
      {/* <Col span={12}>
        <Row>
          <ProFormText name="image" label="面单" ></ProFormText>
        </Row>
        <Row>
          <Upload name="files" maxCount={1}
            action={`${api.uri}/upload/venus-parcel`}
            multiple={false}
            headers={{
              Authorization: 'Bearer ' + localStorage.getItem('token')
            }}
            listType="picture-card"
          >
            <UploadInner>
              {fileList.length < 1 && '+ Upload'}
            </UploadInner>
          </Upload>
        </Row>
      </Col>
      <Col span={12}>
        <Row>
          <ProFormText name="image2" label="实拍" ></ProFormText>
        </Row>
        <Row>
          <UploadStyle>
            <Upload name="files" maxCount={1}
              action={`${api.uri}/upload/venus-parcel`}
              multiple={false}
              headers={{
                Authorization: 'Bearer ' + localStorage.getItem('token')
              }}
              listType="picture-card"

              onChange={onChange}
              onPreview={onPreview}
            >
              <UploadInner>
                {fileList.length < 1 && '+ Upload'}
              </UploadInner>
            </Upload></UploadStyle>
        </Row>
      </Col> */}
      <ProFormTextArea name="comment" label="备注" colProps={{ md: 24 }} ></ProFormTextArea>
    </ModalForm >
  )

};
export default CompleteShipmentForm
